<template>
 <RouterView>

 </RouterView>
</template>

<script>
import {App} from "@capacitor/app";
import {ScreenOrientation} from "@capacitor/screen-orientation";
import {StatusBar} from '@capacitor/status-bar';
import router from "@/router";
import Swals from "@/assets/js/Swals";

export default {
  name: 'App',
  setup(){

    App.addListener('backButton', async () => {

      let url = window.location.href

      if (url.includes('HomePage')) {
        await Swals.Question('آیا از برنامه خارج می شوید؟', 'خروج از برنامه').then((res) => {
          if (res.isConfirmed) {
            App.exitApp()
          }
        });
      }else if(url.includes('/CategoryPage') || url.includes('/MyOrders') || url.includes('/ProfilePage') || url.includes('/AuctionsPage')){

        await router.push({name:'HomePage'})

      } else if(url.includes('/OtpPage') || url.includes('RegisterPage')){

        await router.push({name:'LoginPage'})

      } else if (url.includes('/LoginPage')) {

        await App.exitApp()

      }else if(url.includes('/OffersPage')){

        await router.push({name:'ProfilePage'})

      } else {
        window.history.back()
      }


    })

    StatusBar.setBackgroundColor({color: '#2F3A96'})
    ScreenOrientation.lock({orientation: 'OrientationLockType'})

    window.addEventListener('online' , ()=>{
      Swals.Done('اتصال اینترنت شما برقرار شد :)')
    })
    window.addEventListener('offline' , ()=>{
      Swals.Warning('متاسفانه اتصال اینترنت شما برقرار نیست !')
    })


    return{



    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
